import {post} from './httpBase';

//发票申请
export function invoiceApply(params) {
    // return post('/invoice/invoiceApply', params)
    return post('/order/invoice/apply', params)
}
//发票撤回
export function invoiceBack(params) {
    // return post('/invoice/invoiceRecord', params)
    return post('/order/invoice/back', params)
}
//单个发票详情
export function invoiceDetail(params) {
    // return post('/invoice/invoiceDetail', params)
    return post('/order/invoice/details', params)
}
//所有发票详情列表
export function allInvoiceDetail(params) {
    // return post('/invoice/invoiceDetail', params)
    return post('/order/invoice/historylist', params)
}

//发票订单列表
export function invoiceOrderList(params) {
    return post('/order/invoice/listorder', params)
}
//获取用户姓名列表
export function invoiceNameList(params) {
    return post('/order/invoice/getname', params)
}
// 获取开票乘客信息
export function getpassengerinfo(params) {
    return post('/order/invoice/getpassengerinfo', params)
}


// WEBPACK FOOTER //
// ./src/service/invoiceService.js